import { httpClient } from '../lib/httpClient';
import type {
  LanguagesResponse,
  LanguagesQueryParams,
} from '../interfaces/apiInterfaces/languages';

export async function fetchLanguages(
  params?: LanguagesQueryParams
): Promise<LanguagesResponse> {
  const response = await httpClient.get<LanguagesResponse>('/v1/languages', {
    params,
  });
  return response.data;
}
